export default __webpack_public_path__ + "images/b7dce72bc0e56bc8f4aa9ad4e5d0aa4a.png";